import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import resolvePath from '../../../../misc/resolvePath';
import LoadProgram from '../../../loaders/LoadProgram';
import LoadSpeakers from '../../../loaders/LoadSpeakers';
import WaitWhileBusy from '../../../WaitWhileBusy';
import UserProfile from '../../UserProfile';
import { isSpeeddate } from '../../../../data/filters/schedule/isSpeeddate';
import HasData from '../../../validate/HasData';

const connectSpeakerProfile = connect((state, props) => {
    let event = state.events[props.eventId].event,
        speaker = state.events[props.eventId].speakers.indexed[props.speakerId],
        programItem =
            state.events[props.eventId].schedule.indexed[props.itemId],
        speeddate = isSpeeddate(programItem);

    return {
        event,
        user: {
            ...speaker,
            linkedin_profile_url: speaker.linkedin_url,
        },
        isSpeaker: true,
        i18n: state.i18n.translations,
        inviteURL:
            resolvePath(app.history.location.pathname, 'invite') +
            (speeddate
                ? '?speakers=' + props.speakerId
                : '?users=' + speaker.user_id),
        canBeInvited:
            !event.settings.disable_meetings &&
            event.joined &&
            (speeddate || speaker.user_id),
        programItem,
        returnURL: '..',
        speakerRoles: _(speaker.program_item_ids)
            .map((programId) =>
                _(state).get(
                    `events[${props.eventId}].schedule.indexed[${programId}]`
                )
            )
            .compact()
            .map((programItem) => ({
                programItem,
                roles: programItem.speakers
                    .filter((s) => s.id == speaker.id)
            }))
            .value(),
    };
});

const ConnectedSpeakerProfile = connectSpeakerProfile(UserProfile);

export default (props) => (
    <LoadSpeakers eventId={props.match.params.eventId}>
        <LoadProgram eventId={props.match.params.eventId}>
            <WaitWhileBusy>
                <HasData
                    path={`events[${props.match.params.eventId}].speakers.indexed[${props.match.params.speakerId}]`}>
                    <ConnectedSpeakerProfile {...props.match.params} />
                </HasData>
            </WaitWhileBusy>
        </LoadProgram>
    </LoadSpeakers>
);
